import type { CustomerSort, CustomerSortKey } from '@/lib/customer-sort'

interface CustomerSortHeaderProps {
  label: string
  sortKey: CustomerSortKey
  sort: CustomerSort
  onSort: (key: CustomerSortKey) => void
}

export function CustomerSortHeader({ label, sortKey, sort, onSort }: CustomerSortHeaderProps) {
  const active = sort.key === sortKey
  const indicator = active ? (sort.direction === 'desc' ? '↓' : '↑') : '↕'
  const state = active
    ? sort.direction === 'desc' ? 'по убыванию' : 'по возрастанию'
    : 'сортировка выключена'

  return (
    <button
      type="button"
      onClick={() => onSort(sortKey)}
      className={`group inline-flex min-h-7 items-center gap-1.5 text-left uppercase tracking-[0.1em] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70 ${active ? 'text-ink' : 'text-ink-faint hover:text-ink-muted'}`}
      aria-label={`${label}: ${state}. Нажмите, чтобы изменить сортировку`}
      title={`${label}: ${state}`}
    >
      <span>{label}</span>
      <span
        aria-hidden="true"
        className={`text-[12px] leading-none ${active ? 'font-bold text-gold-deep' : 'font-medium text-ink-faint group-hover:text-ink-muted'}`}
      >
        {indicator}
      </span>
    </button>
  )
}
